const STATUS = {
  PLANEJADA: "PLANEJADA",
  PROGRAMADA: "PROGRAMADA",
  PENDENTE: "PENDENTE",
  ATRASADA: "ATRASADA",
  APLICADA: "APLICADA",
  PULADA: "PULADA",
};

const ONE_HOUR_MS = 60 * 60 * 1000;

export const deriveDoseStatus = (dose) => {
  const now = Date.now();

  const base = String(dose?.status || STATUS.PLANEJADA).toUpperCase();
  const dateMs = dose?.date ? new Date(dose.date).getTime() : null;

  if (base === STATUS.APLICADA) return STATUS.APLICADA;
  if (base === STATUS.PULADA) return STATUS.PULADA;

  if (!dateMs) return STATUS.PENDENTE;
  if (dateMs > now) return STATUS.PROGRAMADA;
  if (now > dateMs + ONE_HOUR_MS) return STATUS.ATRASADA;

  return STATUS.PENDENTE;
};

export const attachDerivedStatus = (doses = []) => {
  return doses.map((d) => ({
    ...d,
    __derivedStatus: deriveDoseStatus(d),
  }));
};